import { isEqual } from "lodash";

import {
    getListById,
    transformContainerFields,
} from "containers/Projects/components/ProjectTree/utils";

export const actions = {
    STORE_PROJECT_DATA: "STORE_PROJECT_DATA",
    STORE_PROJECT_LIST: "STORE_PROJECT_LIST",
    STORE_ACTIVE_PROJECT: "STORE_ACTIVE_PROJECT",
};

export const initialState = {
    isFetching: false,
    list: [],
    activeId: null,
    listById: {},
};

export default (state = initialState, { type, data, iri }) => {
    switch (type) {
        case actions.STORE_PROJECT_LIST: {
            const list = data.map(transformContainerFields);
            // The /ui websocket re-pushes the full project snapshot on any
            // workspace-scoped live update, not only when projects changed.
            // Bail out when the content is identical so `list`/`listById` keep
            // their reference and downstream selectors/memoised consumers (e.g.
            // ProjectTree) do not re-render on every unrelated push.
            if (isEqual(state.list, list)) {
                return state;
            }
            const listById = getListById(data);
            return Object.assign({}, state, {
                list,
                listById,
            });
        }
        case actions.STORE_ACTIVE_PROJECT: {
            return {
                ...state,
                activeId: iri,
            };
        }

        default:
            return state;
    }
};
